import { PdSidebar } from "./pd-sidebar/PdSidebar.js";
//#region src/pd-sidebar/pd-sidebar.ts
var tag = "pd-sidebar";
if (!customElements.get(tag)) customElements.define(tag, PdSidebar);
//#endregion
export { PdSidebar };
